import {
  CALENDAR_SET_COLORS,
  CALENDAR_SET_DATA,
  CALENDAR_SET_METRICS,
} from "../actions/calendar.actions";
import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  data: null,
  colors: {},
  metrics: [],
};

export const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALENDAR_SET_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case CALENDAR_SET_COLORS:
      return {
        ...state,
        colors: action.payload,
      };
    case CALENDAR_SET_METRICS:
      return {
        ...state,
        metrics: action.payload,
      };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
